/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconContrastOff = createSolidComponent("contrast-off", "IconContrastOff", [
  [
    "path",
    {
      d: "M12 12v5a4.984 4.984 0 0 0 3.522 -1.45m1.392 -2.623a5 5 0 0 0 -4.914 -5.927v1"
    }
  ],
  [
    "path",
    {
      d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }
  ],
  ["path", { d: "M3 3l18 18" }]
]);

export { IconContrastOff as default };
//# sourceMappingURL=IconContrastOff.js.map
